import React from "react";
import { useLocation } from "react-router-dom";
import { useGlobal } from "reactn";
import ChampionRankingStats from "components/Champions/ChampionRankingStats";
import AdditionalStats from "components/Champions/AdditionalStats";
import Runes from "./Runes";
import SummonerSpells from "./SummonerSpells";
import Skills from "./Skills";
import ToughestMatchupsHorizontal from "./ToughestMatchupsHorizontal";
import Items from "./Items";
import { getNotFoundImg } from "@outplayed/riot-assets";

import { useUserPremiumState } from "lib/hooks/userHooks";
import { getChampionTransformId } from "lib/general-helper.js";
import BuildTabs from "./BuildTabs";
import { WowPromo, ValorantAppPromo, LoLAppPromo } from "./CrossPromo";

const Build = (props) => {
  const [loggingIn] = useGlobal("loggingIn");
  const location = useLocation();
  const { pathname } = location || {};
  const { isPremium } = useUserPremiumState();

  const {
    page,
    version,
    championId,
    championData,
    championOverview,
    fetchingData,
    filteredRankingStats,
    otpStats,
    role,
    filters,
    missingMatchup,
    queueTypeName,
    renderAdditionalStats,
    championModifications,
    tabData,
    defaultBuild,
    setDefaultBuild,
    isAP,
    isTank,
    isAD,
    isCrit,
    isLethality,
    isOnHit,
    isRed,
    isBlue,
    match,
  } = props;

  if (fetchingData) {
    return (
      <div className="champion-recommended-build">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  let {
    stat_shards,
    rec_runes,
    rec_summoner_spells,
    rec_starting_items,
    rec_core_items,
    rec_skills,
    rec_skill_path,
    rec_skill_evolve_path,
    item_options_1,
    item_options_2,
    item_options_3,
  } = championOverview || {};

  if (
    !rec_runes ||
    !rec_summoner_spells ||
    !rec_starting_items ||
    !rec_core_items ||
    !rec_skills ||
    !rec_skill_path ||
    !item_options_1 ||
    !item_options_2 ||
    !item_options_3
    // ((isAP || isAD || isTank || isCrit || isLethality || isOnHit) &&
    //   (item_options_1.length < 2 ||
    //     item_options_2.length < 3 ||
    //     item_options_3.length < 3 ||
    //     matches.length < 10 ||
    //     rec_starting_items.matches < 10 ||
    //     rec_core_items.matches < 10)
    //     )
  ) {
    return (
      <div className="content-section champion-profile-error champion-recommended-build">
        <img className="not-found" src={getNotFoundImg()} alt="No data found" />
        No data found. Please try again or change filters.
      </div>
    );
  }

  const championName = championData.name;
  const multi = match.params.multi;

  return (
    <div className="champion-recommended-build ">
      <div className="additional-stats-container">
        <ChampionRankingStats
          rankingStats={filteredRankingStats}
          oppChampionOverview={filters.opp && championOverview}
          opp={filters.opp}
          queueType={filters.queueType}
          missingMatchup={missingMatchup}
          renderSpecialStats={renderAdditionalStats}
        />
        {renderAdditionalStats ? (
          <AdditionalStats
            championName={championName}
            queueTypeName={queueTypeName}
            championId={championId}
            championModifications={championModifications}
            championData={championData}
          />
        ) : null}
      </div>
      <div className="rune-spell">
        {tabData && (
          <BuildTabs
            page={page}
            championId={championId}
            version={version}
            defaultBuild={defaultBuild}
            setDefaultBuild={setDefaultBuild}
            tabData={tabData}
            isAP={isAP}
            isTank={isTank}
            isAD={isAD}
            isCrit={isCrit}
            isLethality={isLethality}
            isOnHit={isOnHit}
            isRed={isRed}
            isBlue={isBlue}
            multi={multi}
          />
        )}
        <div className="content-section content-section_unset grid-1 max-sm:!flex max-sm:!flex-col">
          <Runes
            statShards={stat_shards}
            recRunes={rec_runes}
            patch={version}
            championName={championName}
            role={role}
            multi={multi}
          />
          <SummonerSpells recSummonerSpells={rec_summoner_spells} />
          <LoLAppPromo className="max-sm:mt-[12px]" />
        </div>
      </div>
      {pathname && pathname.includes("build") && (
        <div className="mt-[12px]">
          <ToughestMatchupsHorizontal
            championName={championName}
            role={role}
            matchups={(filteredRankingStats && filteredRankingStats.counters) || []}
            multi={multi}
          />
        </div>
      )}
      <Skills
        championId={getChampionTransformId(championId)}
        skillPriority={rec_skills}
        skillPath={rec_skill_path}
        evolutionPath={rec_skill_evolve_path}
        championName={championName}
      />
      <Items
        startingItems={rec_starting_items}
        coreItems={rec_core_items}
        items1={item_options_1}
        items2={item_options_2}
        items3={item_options_3}
        patch={version}
        championName={championName}
      />
    </div>
  );
};

export default Build;
